/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMilitaryAirfield = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M20.834 4.839c-.388-.74-1.27-1.006-1.97-.597L14.583 6.7 6.35 4.077A.85.85 0 0 0 5.998 4c-.487 0-.88.413-.88.926 0 .268.11.51.283.68l.007.004a1 1 0 0 0 .121.097l4.5 3.609-2.59 1.487-3.394-.75a.7.7 0 0 0-.298-.065c-.412 0-.747.35-.747.786a.8.8 0 0 0 .184.515l.002.002a.7.7 0 0 0 .159.143L5.072 13H9.52l10.802-6.273c.634-.372.866-1.216.512-1.888M3.994 17.15c0-.774.006-.65.006-.65s5.756 2.359 8 3c1.644-.595 8-3 8-3v.65c0 .552-.371.924-1 1.1l-6.45 2.578a2 2 0 0 1-1.1 0L4.98 18.25c-.563-.207-.986-.548-.986-1.1" /><path fill="currentColor" d="M3.994 14.657c0-.774.006-.65.006-.65s5.756 2.36 8 3c1.644-.595 8-3 8-3v.65c0 .552-.371.924-1 1.1l-6.45 2.579a2 2 0 0 1-1.1 0l-6.47-2.579c-.563-.207-.986-.548-.986-1.1" /></svg>;
export default SvgMilitaryAirfield;